<template>
  <div>
    <pre class="pageDescription" v-if="pageData.contents[0].description">{{ pageData.contents[0].description }}</pre>

    <div v-for="branch in pageData.childEntries.rows" :key="branch.id" class="branch-card">
      <div class="branch-card__thumbnail">
        <img :src="branch.contents[0].thumb">
      </div>
      <div class="branch-card__details">
        <div class="d-flex flex-row flex-wrap">
          <h5 class="branch-card__title">{{ branch.contents[0].title }}</h5>
          <div class="mx-2" v-if="getJsonData(branch.contents[0].description).mapUrl">
            (
            <a
              class="branch-card__map-url"
              v-bind:href="getJsonData(branch.contents[0].description).mapUrl"
              target="_blank"
            >{{ getCaption("caption.see_map") }}</a>
            )
          </div>
        </div>
        <div class="info_line">
          <div class="smallTitle__fixed">
            <span>{{ getCaption("caption.branch_phone") }}:</span>
          </div>
          {{ getJsonData(branch.contents[0].description).phone }}
        </div>
        <div class="info_line">
          <div class="smallTitle__fixed">
            <span>{{ getCaption("caption.schedule") }}:</span>
          </div>
          {{ getJsonData(branch.contents[0].description).timeTable }}
        </div>
        <div class="info_line">
          <div class="smallTitle__fixed">
            <span>{{ getCaption("caption.address") }}:</span>
          </div>
          {{ getJsonData(branch.contents[0].description).address }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pageData"],

  mounted() {
    this.getJsonData(
      this.pageData.childEntries.rows[0].contents[0].description
    );
  },

  methods: {
    getJsonData(data) {
      let str = data.replace(/\t/, "\\t");
      return JSON.parse(str);
    }
  }
};
</script>


<style lang="scss" scoped>
.branch-card {
  display: flex;
  flex-wrap: wrap;
  margin: 1.5em 0;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.branch-card__details {
  flex: 1;
}

.branch-card__thumbnail {
  width: 100%;

  img {
    width: 100%;
    border-radius: 6px;
    height: 200px;
    object-fit: cover;
    object-position: center;
  }
}

.info_line {
  display: flex;
  margin: 0.2rem 0;

  .smallTitle__fixed {
    display: flex;
    flex: 0 0 130px;
    align-items: right;
    font-weight: 500;
    padding-right: 1rem;

    span {
      // text-align: right;
      display: block;
      width: 100%;
    }
  }
}
.branch-card__title {
  font-weight: 500;
  font-size: 1.3em;
}

.branch-card__map-url {
  text-decoration: underline !important;
  color: dodgerblue;
  &:hover {
    color: royalblue;
  }
}

@media (min-width: $breakpoint-md) {
  .branch-card__thumbnail {
    width: 30%;
  }

  .branch-card__details {
    padding: 0 1em;
  }

  .branch-card__title {
    font-weight: 700;
    text-transform: uppercase;
    font-family: "Roboto Condensed", sans-serif;
  }

  .smallTitle__fixed {
    span {
      text-align: right;
    }
  }
}
.branch-card:first-child {
  margin-top: 0 !important;
}
</style>
